import { listingReviewClient } from '@api/sdk-client';
import { analyticsTraitsControllerGetAnalyticsTraits } from '@webidoo-eng/jooice-listing-review';

export interface IAnalyticsTraits {
  is_spartacus: boolean;
  num_location: number;
  location_tier: 'none' | 'single' | 'multi';
}

// The listing-review SDK bundles its own @hey-api/client-axios types which diverge
// from the top-level package; the analytics-traits response is typed `unknown`
// (ProfileTraits has no Swagger decorators). Cast options + unwrap the envelope.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const opts = (o: Record<string, unknown>) => o as any;

const analyticsAPI = {
  // GET /v1/me/analytics-traits — always-on Mixpanel profile traits for the authed
  // member, fetched so the FE can register num_location/location_tier as super-props.
  getTraits: async (): Promise<IAnalyticsTraits> => {
    const res = await analyticsTraitsControllerGetAnalyticsTraits(opts({ client: listingReviewClient }));
    return (res.data as { data: IAnalyticsTraits }).data;
  },
};

export default analyticsAPI;
